import { SuspendPraticaStepStatusEnum } from "@api/client";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { StepsEnum, SubStepsEnum } from "layout/enums/step.enum";
import { Step } from "layout/models/step.model";

export const OnboardingSteps: Step[] = [
	{
		id: StepsEnum.INIZIAMO,
		icon: "fa-user",
		title: "1. Iniziamo",
		subtitle: "Informazioni su di te",
		route: AppRouterService.get(PathEnum.step1),
		subSteps: [
			{
				id: SubStepsEnum.CREAZIONE_PROFILO,
				title: "Creazione profilo",
				route: AppRouterService.get(PathEnum.creazioneProfilo),
			},
			{
				id: SubStepsEnum.CODICE_ATTIVAZIONE,
				title: "Codice attivazione",
				route: AppRouterService.get(PathEnum.codiceAttivazione),
				backendEnumRef: SuspendPraticaStepStatusEnum.AvviaPratica,
			},
			{
				id: SubStepsEnum.CERCA_IMPRESA,
				title: "Cerca la tua impresa",
				route: AppRouterService.get(PathEnum.cercaImpresa),
				backendEnumRef: SuspendPraticaStepStatusEnum.RicercaAzienda,
			},
		],
	},
	{
		id: StepsEnum.LA_TUA_AZIENDA,
		icon: "fa-shop",
		title: "2. La tua azienda",
		subtitle: "Raccontaci la tua attività",
		route: AppRouterService.get(PathEnum.step2),
		subSteps: [
			{
				id: SubStepsEnum.PRESENTA_AZIENDA,
				title: "Presentaci la tua azienda",
				route: AppRouterService.get(PathEnum.presentaAzienda),
			},
			{
				id: SubStepsEnum.DATI_AZIENDALI,
				title: "Dati aziendali",
				route: AppRouterService.get(PathEnum.datiAziendali),
				backendEnumRef: SuspendPraticaStepStatusEnum.RegistraAzienda,
			},
			{
				id: SubStepsEnum.INDIRIZZI_CONTATTI,
				route: AppRouterService.get(PathEnum.indirizziContatti),
				title: "Indirizzi e contatti",
			},
			{
				id: SubStepsEnum.BILANCIO_IMPRESA,
				route: AppRouterService.get(PathEnum.bilancioImpresa),
				title: "Bilancio impresa",
			},
			{
				id: SubStepsEnum.DETTAGLI_SOCIETA,
				route: AppRouterService.get(PathEnum.dettagliSocieta),
				title: "Dettagli della società",
			},
			{
				id: SubStepsEnum.NEXT_STEP,
				route: AppRouterService.get(PathEnum.step2Complete),
				title: "",
				hideOnMenu: true,
			},
		],
	},
	{
		id: StepsEnum.IDENTIFICAZIONE,
		icon: "fa-user-group",
		title: "3. I tuoi dati",
		subtitle: "Raccolta documenti",
		route: AppRouterService.get(PathEnum.step3),
		subSteps: [
			{
				id: SubStepsEnum.LEGALE_RAPPRESENTANTE,
				title: "Legale rappresentante",
				route: AppRouterService.get(PathEnum.raccontaciDiTe),
				backendEnumRef: SuspendPraticaStepStatusEnum.RicercaRappLegale,
			},
			{
				id: SubStepsEnum.ANAGRAFICA,
				title: "Anagrafica",
				route: AppRouterService.get(PathEnum.anagraficaLR),
			},
			{
				id: SubStepsEnum.CARICHE_PUBBLICHE,
				title: "Ulteriori informazioni",
				route: AppRouterService.get(PathEnum.ulterioriInformazioniLR),
			},
			{
				id: SubStepsEnum.NEXT_STEP,
				title: "",
				route: AppRouterService.get(PathEnum.completeLR),
				hideOnMenu: true,
			},
			{
				id: SubStepsEnum.TITOLARI_EFFETTIVI,
				title: "Titolari effettivi",
				route: AppRouterService.get(PathEnum.sceltaTitolareEffettivo),
				backendEnumRef: SuspendPraticaStepStatusEnum.RicercaTitolari,
			},
			{
				id: SubStepsEnum.ANAGRAFICA_TITOLARE,
				title: "Anagrafica",
				route: AppRouterService.get(PathEnum.anagraficaTE),
			},
			{
				id: SubStepsEnum.CARICHE_PUBBLICHE_TITOLARE,
				title: "Ulteriori informazioni",
				route: AppRouterService.get(PathEnum.ulterioriInformazioniTE),
			},
			{
				id: SubStepsEnum.VERIFICA_IDENTITA,
				title: "Verifica identità",
				route: AppRouterService.get(PathEnum.verificaIdentitaTE),
			},
			{
				id: SubStepsEnum.LAST_SUBSTEP,
				title: "",
				hideOnMenu: true,
				route: AppRouterService.get(PathEnum.completeTE),
			},
		],
	},
	{
		id: StepsEnum.SERVIZI,
		icon: "fa-square-plus",
		title: "4. Servizi",
		subtitle: "Seleziona i prodotti",
		route: AppRouterService.get(PathEnum.step4),
		backendEnumRef: SuspendPraticaStepStatusEnum.ConfiguraServizio,
		subSteps: [
			// {
			// 	id: SubStepsEnum.CONTO_PAGAMENTO,
			// 	title: "Conto di pagamento",
			// 	route: AppRouterService.get(PathEnum.contoPagamento),
			// 	tipoServizi: ["STANDARD", "CONTO"],
			// },
			{
				id: SubStepsEnum.CONVENZIONI_POS,
				title: "Convenzione POS",
				route: AppRouterService.get(PathEnum.pos),
				tipoServizi: ["STANDARD", "CONTO", "PAYMENT_FACILITATOR", "SD", "ACI", "ADV", "WEB_POS"],
			},
			{
				id: SubStepsEnum.NEXT_STEP,
				title: "",
				hideOnMenu: true,
				route: AppRouterService.get(PathEnum.step4Complete),
				tipoServizi: ["STANDARD", "CONTO", "PAYMENT_FACILITATOR", "SD", "ACI", "ADV", "WEB_POS"],
			},
		],
	},
	{
		id: StepsEnum.PAGAMENTI,
		icon: "fa-euro-sign",
		title: "5. Pagamenti",
		subtitle: "Scegli come pagare",
		route: AppRouterService.get(PathEnum.step5),
		backendEnumRef: SuspendPraticaStepStatusEnum.DatiPagamento,
		subSteps: [
			{
				id: SubStepsEnum.MANDATO_ADDEBITO_DIRETTO,
				title: "Mandato di addebito diretto",
				route: AppRouterService.get(PathEnum.step5),
			},
		],
	},
	{
		id: StepsEnum.VERIFICA_IDENTITA,
		icon: "fa-id-card",
		title: "6. Identificazione",
		subtitle: "Verifica la tua identità",
		route: AppRouterService.get(PathEnum.step6),
		backendEnumRef: SuspendPraticaStepStatusEnum.VerificaIdentita,
		subSteps: [
			{
				id: SubStepsEnum.VERIFICA_IDENTITA,
				title: "Verifica Identità",
				route: AppRouterService.get(PathEnum.step6),
			},
		],
	},
	{
		id: StepsEnum.FIRMA_CONTRATTO,
		icon: "fa-file-signature",
		title: "7. Firma",
		subtitle: "Accettazione dei termini",
		route: AppRouterService.get(PathEnum.step7),
		backendEnumRef: SuspendPraticaStepStatusEnum.FirmaContratto,
		subSteps: [
			{
				id: SubStepsEnum.FIRMA,
				title: "Firma",
				route: AppRouterService.get(PathEnum.step7),
			},
		],
	},
	{
		id: StepsEnum.PROCESSO_TERMINATO,
		icon: "fa-file-signature",
		title: "Identificazione e firma",
		subtitle: "Accettazione dei termini",
		route: AppRouterService.get(PathEnum.processoTerminato),
		backendEnumRef: SuspendPraticaStepStatusEnum.FinePratica,
		hideOnMenu: true,
	},
];
